import React from "react";
import triangleIcon from "../../assets/icon/triangle.png";

import "./index.scss";

export const StepNav: React.FC<{ step: number }> = ({ step = 1 }) => {
    return (
        <div className="step-nav">
            <div className={`step-nav-box ${step === 1 ? "active" : ""} noto-sans-jp-extrabold`}>
                ご注文情報の
                ご入力
            </div>
            <img src={triangleIcon} alt="矢印" className="triangle-icon" />
            <div className={`step-nav-box ${step === 2 ? "active" : ""} noto-sans-jp-extrabold`}>
                ご注文内容の
                ご確認
            </div>
            <img src={triangleIcon} alt="矢印" className="triangle-icon" />
            <div className={`step-nav-box ${step === 3 ? "active" : ""} noto-sans-jp-extrabold`}>
                ご注文完了
            </div>
        </div>
    );
};

export default StepNav;
